const makeChunks = <T>(array: T[] = [], chunkSize: number) =>
  Array.from({ length: Math.ceil(array.length / chunkSize) }, (v, i) =>
    array.slice(i * chunkSize, i * chunkSize + chunkSize),
  )

export default makeChunks
